import React, { useEffect, useState } from 'react';

import type { FlagsStateContainer } from '@confluence/flags';

import type { FlagData } from './buildEditorFlagMessage';

export type FlagDescriptionProps = {
	flagContent: FlagData;
	nextTryIn?: number;
	flagId: string;
	flags: FlagsStateContainer;
};

export const FlagDescription = ({
	flagContent,
	nextTryIn,
	flagId,
	flags,
}: FlagDescriptionProps) => {
	const [secondsLeft, setSecondsLeft] = useState<number>(
		nextTryIn
			? // We get nextTryIn in ms
				Math.max(Math.round(nextTryIn / 1000), 0)
			: 0,
	);
	const description =
		typeof flagContent.description === 'function'
			? flagContent.description(secondsLeft)
			: flagContent.description;

	useEffect(() => {
		if (nextTryIn) {
			const flagInterval = setInterval(
				() => setSecondsLeft((secondsLeft) => secondsLeft - 1),
				1000,
			);
			return () => clearInterval(flagInterval);
		}
	}, [nextTryIn]);

	// Clean the flag up if the flag is a count down flag
	// and the countdown reached its end
	if (nextTryIn && secondsLeft < 0) {
		void flags.hideFlag(flagId);
	}

	return (
		<div data-testid="flag-description">
			{description}
			{flagContent.details && <div data-testid="flag-details">{flagContent.details}</div>}
		</div>
	);
};
